import { useState } from 'react';

import BoardArtworkPreview from '@/shared-components/forms/add-board-content/board-text-body/add-element/add-board-artwork/BoardArtworkPreview';

import ArtworkCarousel from './ArtworkCarousel';

export default function ArtworkDisplay({
  groupedArtworks,
  onArtworkRemove,
  navigate, // important to pass it here, it cannot be within the artwork carousel
  location, // important to pass it here, it cannot be within the artwork carousel
  previewMode = false, // TODO: Check previewMode usage
}) {

  const [internalArtworks, setInternalArtworks] = useState(groupedArtworks.artworks);
  
  const internalDelete = (groupId, artworkId) => {
    const updatedArtworks = internalArtworks.filter(pic => pic.artworkId !== artworkId);
    setInternalArtworks(updatedArtworks);
    onArtworkRemove(groupId, artworkId);
  };

  if (internalArtworks.length === 0) return null;

  if (internalArtworks.length === 1) {
    const artwork = internalArtworks[0];

    return (
      <div
        data-atomic="true"
        data-group="media"
        id={`artwork-${artwork.artworkId}`}
        contentEditable={false}
      >
        <BoardArtworkPreview
          image={artwork.imageUrl}
          caption={artwork.caption}
          slug={artwork.slug}
          onRemove={previewMode ? undefined : () => internalDelete(groupedArtworks.groupId, artwork.artworkId)}
          previewMode={previewMode}
        />
      </div>
    );
  }

  return (
    <div
      data-atomic="true"
      data-group="media"
      id={`group-artworks-${groupedArtworks.groupId}`}
      contentEditable={false}
    >
      <ArtworkCarousel
        groupId={groupedArtworks.groupId}
        artworks={internalArtworks}
        onRemoveArtwork={internalDelete}
        previewMode={previewMode}
        readOnly={true}
        navigate={navigate}
        location={location}
      />
    </div>
  );
}
